import React, { useEffect, useRef, useState } from "react";
import ScrollableGameSection from "./ScrollableGameSection";
import { useTranslation } from "react-i18next";
import { Game } from "../types/Game";
import { fetchTopPlayedGames } from "../api/html5GamesApi";
import RoundLoader from "../common/RoundLoader"; // Loader component
import { useNavigate } from "react-router-dom";
const StaticTopGames: React.FC = () => {
  const { t } = useTranslation();
  const featuredRef = useRef<HTMLDivElement | null>(null);
  const [games, setGames] = useState<Game[]>([]);
  const [loading, setLoading] = useState(true);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const navigate = useNavigate();
  const scroll = (dir: "left" | "right") => {
    if (!featuredRef.current) return;
    featuredRef.current.scrollBy({
      left: dir === "left" ? -300 : 300,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const loadTopGames = async () => {
      try {
        const topGames = await fetchTopPlayedGames();
        setGames(topGames);
      } catch (error) {
        console.error("Failed to fetch top games", error);
      } finally {
        setLoading(false);
      }
    };
    loadTopGames();
  }, []);

  useEffect(() => {
    const checkScroll = () => {
      const el = featuredRef.current;
      if (!el) return;
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    };

    if (featuredRef.current) {
      featuredRef.current.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
      checkScroll();
    }

    return () => {
      if (featuredRef.current) {
        featuredRef.current.removeEventListener("scroll", checkScroll);
      }
      window.removeEventListener("resize", checkScroll);
    };
  }, [games]);

  if (loading) return <RoundLoader />;

const toSlug = (str = "") =>
  str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  return (
    <ScrollableGameSection
      title={`🎮 ${t("game.topGames")}`}
      games={games}
      refObj={featuredRef}
      scrollHandler={scroll}
       onCardClick={(game) =>
                    navigate(`/game/${toSlug(game.name)}`, { state: { game } })
                  }
      canScrollLeft={canScrollLeft}
      canScrollRight={canScrollRight}
      sectionType="featured"
    />
  );
};

export default StaticTopGames;
